import React from 'react';
import { useDispatch } from 'react-redux';

import PageHandler from '@jpp/shared/PageHandler';
import Cart from '@jpp/templates/Cart';
import { clearPage } from 'common/redux/page/actions';
import { EPageType } from 'common/typings/enums';

const CartPage: React.FunctionComponent = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    return () => {
      dispatch(clearPage());
    };
  }, []);

  return (
    <PageHandler
      pageType={EPageType.Cart}
      page={{
        title: 'My Cart',
      }}
      template={Cart}
    />
  );
};

export default CartPage;
